'use client';

import React, { useEffect } from 'react';
import { Loader } from '@mantine/core';
import { LANGUAGES } from '@/language';
import CenterLayout from '@/layout/CenterLayout';
import BlogCard from './_components/BlogCard';
import TagSidebar from './_components/TagSidebar';
import BlogPageSkeleton from './_components/BlogPageSkeleton';
import { BlogItem } from './types';
import { useFetchBlogs, useFetchTags } from './_hook';
import { useSearchParams } from 'next/navigation';
import { setLanguage } from '@/utils/localStorageControl';

export default function BlogsPage() {
  const searchParams = useSearchParams();
  const defaultLang = 'ko'; // Default language
  
  const { data: blogs, loading, refresh: refreshBlogs } = useFetchBlogs(searchParams.get('tag') || '');

  useEffect(() => {
    refreshBlogs();
  }, [searchParams.get('tag')]);

  const pageTitle = LANGUAGES.BLOG_PAGE?.['블로그 및 트렌드']?.[defaultLang] || 'Blogs & Trends';

  return (
    <CenterLayout>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">
          {pageTitle}
        </h1>
      </div>

      {loading ? (
        <BlogPageSkeleton count={9} />
      ) : (
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:hidden">
            <TagSidebar />
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 gap-y-12">
              {blogs?.result.map((post: any) => (
                <div key={post.id}>
                  <BlogCard blog={post}/>
                </div>
              ))}
            </div>
          </div>

          {/* Desktop Sidebar - Right, Sticky */}
          <div className="hidden lg:block lg:w-80">
            <TagSidebar className="sticky top-20" />
          </div>
        </div>
      )}
    </CenterLayout>
  );
} 